import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-contact-picker-type-modal',
  templateUrl: './contact-picker-type-modal.html',
  styleUrls: ['./contact-picker-type-modal.scss'],
})
export class ContactPickerTypeModalComponent implements OnInit, OnDestroy {
  @Input() contactType: 'NOT_SPECIFIED' | 'PROSPECT' | 'CLIENT';

  types = [
    { key: 'NOT_SPECIFIED', value: 'No Calificado', class: 'not-specified' },
    { key: 'PROSPECT', value: 'Prospecto', class: 'prospect' },
    { key: 'CLIENT', value: 'Cliente', class: 'client' },
  ];
  destroyed$ = new Subject<boolean>();
  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService
  ) {
    this.translate
      .get(['CONTACTS_MODULE'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => {
        this.types[0].value = t.CONTACTS_MODULE.CONTACT_TYPES.not_specified;
        this.types[1].value = t.CONTACTS_MODULE.CONTACT_TYPES.prospect;
        this.types[2].value = t.CONTACTS_MODULE.CONTACT_TYPES.client;
      });
  }

  ngOnInit() {}

  ngOnDestroy() {}

  selectTypeContact(type) {
    const typeSelected = type;
    this.modalCtrl.dismiss({ data: typeSelected });
  }

  async close() {
    this.modalCtrl.dismiss();
  }
}
